import checkedIcon from "../../images/checked.svg";
import cn from "../../lib/classnames";
import React, {useState} from "react";
import styles from "./RadioInput.module.css";
import textStyles from "../../styles/Text.module.css";
import uncheckedIcon from "../../images/unchecked.svg";

type Props = {
    value: number;
    setValue: (n: number) => void;
    selectedValue: number;
    label: string;
    className?: string;
    loading?: boolean;
    extraInfo?: string;
};

const strings = {
    checked: "checked",
    unchecked: "unchecked",
};

export default function RadioInput(props: Props) {
    const [focused, setFocused] = useState(false);
    const checked = props.value === props.selectedValue;
    const id = `${props.label}-${props.value}`;
    return (
        <>
            <input
                className={styles.input}
                onChange={() => {
                    if (!props.loading) {
                        props.setValue(props.value);
                    }
                }}
                name="radio"
                type="radio"
                checked={checked}
                id={id}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            />
            <label
                className={cn(
                    styles.container,
                    checked ? undefined : styles.faded,
                    props.className,
                    props.loading ? styles.disabled : undefined,
                )}
                htmlFor={id}
            >
                <img
                    className={styles.icon}
                    src={checked ? checkedIcon : uncheckedIcon}
                    alt={checked ? strings.checked : strings.unchecked}
                />
                <div className={styles.label}>{props.label}</div>
            </label>
            {props.extraInfo ? (
                <div
                    className={cn(
                        textStyles.inputDetail,
                        styles.extraInfo,
                        focused ? styles.expanded : styles.collapsed,
                    )}
                >
                    {props.extraInfo}
                </div>
            ) : null}
        </>
    );
}
